<div class="ziro-admin-page-content" data-automation="ziro-high-availability-settings">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1 pb-2" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;pages.admin.high.availability.management.description' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <div class="list-group list-group-striped border-rad-all-12 card-shadow mb-2">
      @for (config of formConfig.fields | keyvalue: returnZero; track config; let i = $index) {
        <div class="list-group-item position-relative">
          @if (isCheckBox(config.value)) {
            <div>
              <ziro-general-settings-checkbox [fieldId]="config.key"></ziro-general-settings-checkbox>
              <p
                [innerHTML]="
                  'tkey;pages.admin.high.availability.management.enable.high.availability.content'
                    | escapeHtml: { hours: String(formData.syncIntervalInHours) }
                "
              ></p>
            </div>
          }
          @if (isTextInput(config.value)) {
            <div class="align-items-center d-flex group-item-text-wrapper justify-content-between">
              <div
                class="col-12 global-config-text-container"
                [attr.data-automation]="config.value.dataAutomation + '-field'"
              >
                <ziro-general-settings-text [fieldId]="config.key"></ziro-general-settings-text>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
